module.exports = __webpack_public_path__ + "img/5b9b696.png";